import { FC, ReactNode } from "react";
import { Input, InputProps } from "@chakra-ui/react";
import { useField } from "formik";
import { InputWrapper } from "./InputWrapper";

// TODO: Make this extend `InputGroupProps` -- https://app.clickup.com/t/8676zwc34
interface Props extends InputProps {
  color?: string;
  description?: string;
  hideLabel?: boolean;
  id?: string;
  inputLeftElement?: ReactNode;
  inputProps?: InputProps;
  inputRightElement?: ReactNode;
  label?: string;
  labelProps?: any;
  labelVariant?: string;
  minH?: string;
  name?: string;
  placeholder?: string;
  variant?: string;
}

export const TextInput: FC<Props> = ({
  color,
  description,
  hideLabel = false,
  inputLeftElement,
  inputProps,
  inputRightElement,
  label,
  labelProps,
  labelVariant,
  placeholder = "",
  variant,
  ...props
}) => {
  const [field, meta] = useField(props as any);
  const type = "text";
  const inputId = `${type}-input-${props.id || props.name}`;

  return (
    <InputWrapper
      id={inputId}
      color={color ?? "inherit"}
      description={description}
      hideLabel={hideLabel}
      inputLeftElement={inputLeftElement}
      inputRightElement={inputRightElement}
      label={label}
      labelProps={labelProps}
      labelVariant={labelVariant}
      meta={meta}
      type={type}
      {...props}
    >
      <Input
        {...field}
        color={color ?? "inherit"}
        bg="on-accent"
        fontSize={props.fontSize}
        id={inputId}
        isInvalid={meta.touched && !!meta.error}
        placeholder={placeholder}
        variant={variant}
        {...inputProps}
      />
    </InputWrapper>
  );
};
